"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
/** Shared Mango brand and form styling – use across dashboard, mango-*, content-creator, desktop-admin */
exports.theme = {
    colors: {
        primary: '#ff6b35',
        primaryGradient: 'linear-gradient(135deg, #ff9a56, #ff6b35)',
        card: '#18181b',
        input: '#27272a',
        inputBorder: '#27272a',
        text: '#fff',
        textMuted: '#a1a1aa',
        errorBg: 'rgba(239,68,68,0.2)',
        errorText: '#fca5a5',
        disabled: '#52525b',
    },
    radii: {
        card: 20,
        input: 12,
        button: 12,
        error: 10,
    },
    spacing: {
        inputPadding: 14,
        cardPadding: 32,
    },
};
